import { TileActionText } from './TileActionText.jsx';
import { CloseButton } from './TileActionButtons.jsx';

import { LeftButton } from './StyledComponents';

export const CampaignPreviewFormMenu = ({
  campaignContainer,
  postId,
  tileStatus,
  publishDate,
  onClose,
  uuid,
}) => {
  return (
    <>
      <LeftButton mode="outline" variant="black" onClick={onClose}>
        <CloseButton />
      </LeftButton>
      <TileActionText
        publishDate={publishDate}
        tileStatus={tileStatus}
        postId={postId}
        campaignContainer={campaignContainer}
        uuid={uuid}
      />
    </>
  );
};
